import { Input, InputProps } from "antd"
import { InputRef, TextAreaProps } from "antd/es/input"

export default function BaseInput(props: InputProps) {
  const { className = "", ...rest } = props
  return (
    <Input
      className={`${className} text-dark-2 dark:text-dark-6 h-9 rounded-lg bg-transparent border dark:border-border border-light-border w-full dark:placeholder:text-[#FFFFFF99] placeholder:text-[#BFBFBF] bg-white dark:bg-dark-1`}
      {...rest}
    />
  )
}

export function BaseInputWithIcon(
  props: InputProps & {
    inputRef?: React.RefObject<InputRef>
    inputClassName?: string
  }
) {
  const { className = "", inputRef, inputClassName = "", ...rest } = props
  return (
    <Input
      ref={inputRef}
      className={`text-white h-10 rounded-lg bg-transparent dark:bg-dark-1 border dark:border-border border-gray-300 w-full hover:bg-transparent hover:border dark:hover:border-white focus-within:bg-transparent focus-within:border dark:focus-within:border-white focus-within:border-primary placeholder:text-[#BFBFBF] ${className}`}
      classNames={{
        input: `${inputClassName} dark:!text-white !text-dark-2 text-13 bg-transparent border border-border w-full placeholder:text-gray-500 placeholder:text-13`
      }}
      {...rest}
    />
  )
}

export function BaseInputTextArea(props: TextAreaProps) {
  const { className = "", ...rest } = props
  return (
    <Input.TextArea
      className={`rounded-lg focus-within:border-primary hover:border-primary dark:bg-dark-1 bg-white border-[#9CA3AF] dark:border-[#9CA3AF] dark:hover:border-white w-full dark:placeholder:text-[#FFFFFF99] text-dark-2 dark:text-dark-6 ${className}`}
      {...rest}
    />
  )
}

export function BaseInputPassword(props: InputProps) {
  const { className = "", ...rest } = props
  return (
    <Input.Password
      className={`h-10 rounded-lg focus-within:border-primary hover:border-primary  border border-gray-300 w-full placeholder:text-[#fff] bg-transparent ${className}`}
      {...rest}
      classNames={{
        input:
          "text-dark dark:text-dark-6 text-13 bg-transparent w-full placeholder:text-[#BFBFBF]"
      }}
    />
  )
}
